import React, { Component, useEffect } from 'react'
import { Auth } from 'aws-amplify'
import qs from 'qs'
import axios from 'axios'
import Layout from '../Layout'
import ForgotPasswordForm from './ForgotPasswordForm'
import ValidationRules from '../../validation/validationRules'
import { OnboardingService } from '../../services/onboardingService'

const errors = {
  invalid_credentials: new Error('Invalid Credentials'),
  CodeMismatchException: new Error('Código inválido'),
  ExpiredCodeException: new Error('Código expirado'),
  InternalErrorException: new Error('Erro ao processar. Tente novamente mais tarde!'),
  InvalidParameterException: new Error('Parâmetro inválido'),
  InvalidPasswordException: new Error('Senha inválida'),
  LimitExceededException: new Error('Limite de tentativas excedido. Tente novamente mais tarde!'),
  NotAuthorizedException: new Error('Usuário não está autorizado'),
  TooManyFailedAttemptsException: new Error('Limite de tentativas excedido. Tente novamente mais tarde!'),
  TooManyRequestsException: new Error('Limite de tentativas excedido. Tente novamente mais tarde!'),
  UserNotFoundException: new Error('Usuário não é encontrado.'),
  CodeDeliveryFailureException: new Error('Falha ao enviar o código.'),
  UsernameEmpty: new Error('O nome de usuário não pode estar vazio.')
}
const onboardingCookieName = 'participantInfo'

import OnDemandLiveRegion from 'on-demand-live-region'

class ForgotPasswordPage extends Component {
  constructor(props) {
    super(props)
    const error = ''
    this.state = {
      usernamePolicy: `${process.env.RAZZLE_USERNAME_POLICY}`,
      isConfirmed: false,
      isCodeSet: false,
      isCodeSent: false,
      isLoading: false,
      isEnableToken: false,
      code: '',
      userPoolWebClientId: '',
      login: '',
      password: '',
      passwordConfirmation: '',
      isSendingCode: false,
      isSendingConfirmation: false,
      isConfirmationForgotPass: false,
      isConfirmationResendEmail: false,
      isConfirmationResendPass: false,
      email: '',
      phone: '',
      statusCognito: '',
      contact: '',
      timeLeft: 180,
      passwordError: error && (errors[error] || new Error(error)),
      error: error && (errors[error] || new Error(error))
    }
  }

  componentDidMount() {
    const userPoolId = process.env.RAZZLE_USER_POOL_ID
    const region = process.env.RAZZLE_APP_REGION
    const { usernamePolicy } = this.state
    const { client_id: userPoolWebClientId } = qs.parse(this.props.location.search.substring(1))

    Auth.configure({ userPoolId, userPoolWebClientId, region })
    const { email, phone, username, statusCognito } = qs.parse(this.props.location.state)

    if (usernamePolicy === 'CPF') {
      this.setState({
        email: email,
        phone: phone,
        login: username.replace(/\D/g, ''),
        statusCognito: statusCognito,
        userPoolWebClientId: userPoolWebClientId
      })
    } else {
      this.setState({
        email: email,
        phone: phone,
        login: username,
        statusCognito: statusCognito,
        userPoolWebClientId: userPoolWebClientId
      })
    }
  }

  handleChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value, error: undefined })
  }

  handleSendCode = (event) => {
    event.preventDefault()
    const { login, email, phone } = this.state

    const handleSuccess = () => {
      OnboardingService.PostLog({
        actionName: 'forgotPasswordRequestCode',
        requestPath: window.location.href,
        requestBody: login,
        statusCode: '204',
        url: window.location.origin,
        message: '[FORGOT-PASSWORD-CODE], [SUCCESS]'
      })
      this.setState({
        isCodeSet: true,
        isSendingCode: false,
        isEnableToken: false,
        timeLeft: 180
      })
      this.startTimer()
    }

    const handleError = (error) => {
      OnboardingService.PostLog({
        actionName: 'forgotPasswordRequestCode',
        requestPath: window.location.href,
        requestBody: login,
        d: JSON.stringify(error),
        statusCode: '400',
        url: window.location.origin,
        message: '[FORGOT-PASSWORD-CODE], [ERROR]'
      })
      if (error === 'Username cannot be empty') {
        error = {
          code: 'UsernameEmpty'
        }
      }
      this.setState({ isSendingCode: false, error: errors[error.code] })
    }

    this.setState({ isSendingCode: true })

    Auth.forgotPassword(login).then(() => {
      handleSuccess()
    }).catch(handleError)
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { login, code, password } = this.state

    const rules = ValidationRules.rulesPass
    const validationPass = ValidationRules.testRules(rules)(password)
    if (!validationPass) {
      this.setState({ passwordError: new Error('Senha inválida.') })
      return
    }
    this.setState({ passwordError: undefined })

    const handleSuccess = () => {
      OnboardingService.PostLog({
        actionName: 'forgotPasswordSubmit',
        requestPath: window.location.href,
        requestBody: login,
        statusCode: '204',
        url: window.location.origin,
        message: '[FORGOT-PASSWORD], [SUCCESS]'
      })

      document.cookie = `${onboardingCookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
      this.setState({
        isSendingConfirmation: false,
        isConfirmationForgotPass: true
      })
    }

    const handleError = (error) => {
      OnboardingService.PostLog({
        actionName: 'ForgotPasswordSubmit',
        requestPath: window.location.href,
        requestBody: login,
        responseBody: JSON.stringify(error),
        statusCode: '400',
        url: window.location.origin,
        message: '[FORGOT-PASSWORD], [ERROR]'
      })
      if (error === 'Username cannot be empty') {
        error = {
          code: 'UsernameEmpty'
        }
      }
      this.setState({ isSendingConfirmation: false, error: errors[error.code] })
    }

    this.setState({ isSendingConfirmation: true })

    Auth.forgotPasswordSubmit(login, code, password).then(() => {
      handleSuccess()
    }).catch(handleError)
  }

  handleResendPass = (event) => {
    event.preventDefault()

    this.setState({ isLoading: true })

    const { login } = this.state

    axios({
      url: `${process.env.RAZZLE_ONBOARDING_API}/api/participant/ResendInvitation`,
      method: 'POST',
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY
      },
      data: {
        documentNumber: login,
        projectId: process.env.RAZZLE_CAMPAIGN_ID
      }
    })
      .then((response) => {
        this.setState({ isLoading: false })
        if (response.data.data) {
          document.cookie = `${onboardingCookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
          this.setState({
            isConfirmationResendPass: true
          })
        } else {
          this.setState({
            error: new Error('Erro ao enviar e-mail.')
          })
        }
      })
      .catch((err) => {
        this.setState({
          error: new Error('Erro ao enviar e-mail.'),
          isLoading: false
        })
      })
  }

  handleResendConfirmEmail = (event) => {
    event.preventDefault()
    this.setState({ isLoading: true })
    const { login } = this.state

    const handleSuccess = () => {
      OnboardingService.PostLog({
        actionName: 'ResendSignUp',
        requestPath: window.location.href,
        requestBody: login,
        statusCode: '204',
        url: window.location.origin,
        message: '[RESEND-COMFIRM-EMAIL], [SUCCESS]'
      })
      document.cookie = `${onboardingCookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
      this.setState({
        isConfirmationResendEmail: true
      })
    }

    const handleError = (error) => {
      OnboardingService.PostLog({
        actionName: 'ResendSignUp',
        requestPath: window.location.href,
        requestBody: login,
        responseBody: JSON.stringify(error),
        statusCode: '400',
        url: window.location.origin,
        message: '[RESEND-COMFIRM-EMAIL], [ERROR]'
      })
      this.setState({
        error: new Error('Erro ao enviar e-mail.'),
        isLoading: false
      })
    }

    Auth.resendSignUp(login).then(() => { 
      handleSuccess()
    }).catch(handleError)
  }

  countDown() {
    this.setState({ timeLeft: this.state.timeLeft - 1 })
    if (this.state.timeLeft === 0) {
      clearInterval(this.state.timer)
      this.setState({ isEnableToken: true })
    }
  }

  startTimer() {
    this.setState({
      timer: setInterval(() => {
        this.countDown()
      }, 1000)
    })
  }

  render() {
    return (
      <Layout>
        <ForgotPasswordForm
          {...this.state}
          handleChange={this.handleChange}
          handleSendCode={this.handleSendCode}
          handleSetCode={this.handleSetCode}
          handleSubmit={this.handleSubmit}
          handleResendPass={this.handleResendPass}
          handleResendConfirmEmail={this.handleResendConfirmEmail}
          location={location}
        />
      </Layout>
    )
  }
}

export default ForgotPasswordPage
